import React, { useEffect, useRef, useState } from 'react';
import { Sunset, Heart, Shield, Home, Users, Anchor, Camera } from 'lucide-react';
import { costData } from '../../data/mock';

const CostSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const iconMap = { Sunset, Heart, Shield, Home, Users, Anchor, Camera };

  return (
    <section 
      ref={sectionRef}
      className="py-32 bg-[#efede6] relative"
    >
      <div className="max-w-5xl mx-auto px-8">
        {/* Title */}
        <div className="text-center mb-20">
          <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#202020] leading-tight tracking-tight transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {costData.title}
          </h2>
        </div>

        {/* Cost Items */}
        <div className="grid md:grid-cols-2 gap-6 mb-20">
          {costData.costs.map((cost, index) => {
            const Icon = iconMap[cost.icon];
            return (
              <div 
                key={index}
                className={`group bg-white rounded-2xl p-8 transition-all duration-500 hover:shadow-xl ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                style={{ transitionDelay: `${(index + 1) * 150}ms` }}
              >
                <div className="flex items-start gap-5">
                  <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-[#efede6] flex items-center justify-center group-hover:bg-[#202020] transition-colors duration-300">
                    <Icon className="w-6 h-6 text-[#202020]/60 group-hover:text-[#efede6] transition-colors duration-300" />
                  </div>
                  <p className="text-lg text-[#202020]/80 leading-relaxed pt-3">
                    {cost.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* Highlight */}
        <div className={`text-center transition-all duration-1000 delay-600 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
          <div className="inline-block bg-[#202020] text-[#efede6] rounded-3xl px-12 py-10 max-w-2xl">
            <h3 className="text-2xl font-normal mb-3">{costData.highlight.title}</h3>
            <p className="text-[#efede6]/60 text-lg">{costData.highlight.content}</p>
          </div>
        </div>

        {/* Conclusion */}
        <p className={`text-center text-lg text-[#202020]/50 mt-16 max-w-2xl mx-auto leading-relaxed transition-all duration-1000 delay-800 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {costData.conclusion}
        </p>
      </div>
    </section>
  );
};

export default CostSection;
